// @core/api/endpoints/document/reset_numbering_counter.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  NumberingSchemeResponse,
  ResetNumberingCounterRequest,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Reset counter
 * Resets the sequence counter for the specified numbering scheme and scope. Admin only.
 */
export async function ResetNumberingCounter(
  scheme_id: string,
  data: ResetNumberingCounterRequest,
  options?: RequestOptions
): Promise<NumberingSchemeResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/numbering-schemes/:scheme_id/reset`;
  requestPath = requestPath.replace(':scheme_id', encodeURIComponent(scheme_id));
  const requestOptions = options;
  return client.post<NumberingSchemeResponse>(requestPath, data, requestOptions);
}
